// Autogenerated file
export const carPlanningStatusesEnum = {
    Booked: "Booked",
    HasPlannedBid: "HasPlannedBid",
    NoActiveBid: "NoActiveBid",
    AtUnloading: "AtUnloading",
    HasNoPlannedBid: "HasNoPlannedBid",
};
export const carPlanningStatuses = [
    { label: "Забронировано", value: "Booked" },
    { label: "Запланирована заявка по приезду", value: "HasPlannedBid" },
    { label: "Простаивает без заявки", value: "NoActiveBid" },
    { label: "На выгрузке", value: "AtUnloading" },
    { label: "Не запланирована заявка по приезду", value: "HasNoPlannedBid" },
];
